
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/ProjectFiltersChecked/ProjectFiltersChecked.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./ProjectFiltersChecked.html');
        
        var script = require('./ProjectFiltersChecked.ts').default;
        module.exports = require('./ProjectFiltersChecked.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    